import { Toaster as Sonner, toast } from "sonner";
import { useCanvasStore } from "@/stores/canvasStore";

type ToasterProps = React.ComponentProps<typeof Sonner>;

// Toasts follow the app's own theme (the canvas store's dark mode, which sets
// the .dark class), not the OS: there is no next-themes provider in this app.
// Raised paper, a hairline and the float shadow, like every other floating surface.
const Toaster = ({ ...props }: ToasterProps) => {
  const isDarkMode = useCanvasStore((s) => s.isDarkMode);

  return (
    <Sonner
      theme={isDarkMode ? "dark" : "light"}
      className="toaster group"
      duration={3000}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:rounded-[14px] group-[.toaster]:bg-paper-raised group-[.toaster]:text-ink group-[.toaster]:border-line group-[.toaster]:shadow-float group-[.toaster]:font-sans group-[.toaster]:text-[13px]",
          description: "group-[.toast]:text-ink-3",
          actionButton: "group-[.toast]:rounded-full group-[.toast]:bg-ink group-[.toast]:text-paper-raised",
          cancelButton: "group-[.toast]:rounded-full group-[.toast]:bg-wash group-[.toast]:text-ink-2",
          // Only the icon carries the danger color; the words stay ink
          error: "[&_[data-icon]]:text-danger",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
